import React from 'react';
import cn from 'classnames';

export const DraggableIcon = ({ width, height, fill, className, ...rest }) => {
  return (
    <svg
      viewBox='0 0 10 16'
      focusable='false'
      width={width}
      height={height}
      className={cn('icon icon-draggable', className)}
      {...rest}
    >
      <path
        fill={fill}
        d='M11 18a2 2 0 1 1-2-2 2.006 2.006 0 0 1 2 2zm-2-8a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2zm0-6a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2zm6 4a2 2 0 1 0-2-2 2.006 2.006 0 0 0 2 2zm0 2a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2zm0 6a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2z'
        transform='translate(-7 -4)'
      />
    </svg>
  );
};

DraggableIcon.defaultProps = {
  width: 10,
  height: 16,
  fill: '#80808a'
};
